import React, { useMemo, useState } from "react";
import { toastMessage } from "../../../utils/toastMessage";
import {
  allowAlphaNumericWithLeadingAlpha,
  allowNumber,
} from "../../../utils/inputValueValidation";
import contact_img from "../../../assets/contact_img.png";
import { contentUsApi } from "../../../services/common";
import { Button, Input, TextArea } from "../../../components/header/form";
import useButtonLoader from "hooks/useButtonLoader";

import { verifyEmail } from "../../../utils/commonHelper";
const ContentUs = () => {
  const [submitButtonElement, setSubmitButtonElement] = useButtonLoader();

  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [error, setError] = useState({});

  const { name, email, phone, message } = contactData;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      setContactData({
        ...contactData,
        [name]: allowAlphaNumericWithLeadingAlpha(value),
      });
    } else if (name === "phone") {
      setContactData({
        ...contactData,
        [name]: allowNumber(value),
      });
    } else if (name === "email") {
      setContactData({
        ...contactData,
        [name]: value.replace(/[^a-zA-Z0-9@._]/g, "").toLowerCase(),
      });
    } else {
      setContactData({ ...contactData, [name]: value });
    }
  };

  const isButtonDisabled = useMemo(() => {
    if (name && phone && email && message) {
      return false;
    }

    return true;
  }, [name, phone, message, email]);

  // validation
  const handleValidation = () => {
    let errorMessage = {};
    let status = true;

    if (!name) {
      errorMessage[`name`] = "Please enter your name";
      status = false;
    }

    if (!phone) {
      errorMessage[`phone`] = "Please enter your mobile number";
      status = false;
    }

    if (!email) {
      errorMessage[`email`] = "Please enter your email address";
      status = false;
    } else if (!verifyEmail(email)) {
      errorMessage["email"] = "Please enter a valid email address";
      errorMessage["emailErr"] = true;
      status = false;
    }

    if (!email) {
      errorMessage[`email`] = "Please enter message";
      status = false;
    }

    setError(errorMessage);
    return status;
  };

  //----------create-content-us-API-----------------------
  const contactUsHandler = async (e) => {
    e.preventDefault();
    if (handleValidation())
      try {
        setSubmitButtonElement(true);

        let payload = {
          name,
          email,
          phone,
          message,
        };
        const res = await contentUsApi(payload);
        if (res?.data?.success) {
          setContactData({ name: "", email: "", message: "", phone: "" });
          toastMessage(res?.data?.message, "success", "Contact Us");
        } else {
          toastMessage(res?.data?.message, "error", "Contact Us");
        }
      } catch (e) {
        toastMessage(
          "Failed to submit. Please try again!",
          "error",
          "Contact Us"
        );
        console.log(e);
      } finally {
        setSubmitButtonElement(false);
      }
  };
  return (
    <section className="contact_us" id="contact">
      <div className="custom_container">
        <div className="contact_heading">
          <div className="row">
            <div className="col-md-12">
              <div className="contact_us_title">
                <h4>CONTACT US</h4>
              </div>
              <div className="key_heading contact">
                <h2>Get in touch with us.</h2>
              </div>
            </div>
            <div className="contact_heading">
              <div className="custom_container">
                <div className="row contactus_row">
                  <div className="col-sm-6 col-md-6 col-lg-5">
                    <div className="contact_img">
                      <img src={contact_img} alt="" />

                      <p>
                        In case of any issues during login/sign-up, drop a
                        WhatsApp at +1 905 490 1212
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="contact_form">
                      <div className="form-container">
                        <form onSubmit={contactUsHandler}>
                          <div className="form_field_wrap">
                            <div className="form_field">
                              <Input
                                type="text"
                                className="form-input contact"
                                placeholder="Name*"
                                required
                                name="name"
                                value={name}
                                onChange={handleInputChange}
                                error={error?.name}
                              />
                            </div>
                            <div className="form_field">
                              <Input
                                type="tel"
                                className="form-input contact"
                                placeholder="Phone No*"
                                required
                                maxLength={15}
                                name="phone"
                                value={phone}
                                onChange={handleInputChange}
                                error={error?.phone}
                              />
                            </div>
                          </div>
                          <div className="form_field">
                            <div className="form_field">
                              <Input
                                type="email"
                                className="form-input contact"
                                placeholder="Email*"
                                required
                                name="email"
                                value={email}
                                onChange={handleInputChange}
                                error={error?.email}
                                extraError={error?.emailErr}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <TextArea
                              className="form-input form-textarea contact"
                              placeholder="Message*"
                              required
                              name="message"
                              value={contactData?.message}
                              onChange={handleInputChange}
                              error={error?.message}
                            />
                          </div>
                          <div className="button_wrap">
                            <Button
                              type="submit"
                              className={`form-button`}
                              {...submitButtonElement}
                              disabled={
                                isButtonDisabled ||
                                submitButtonElement?.disabled
                              }
                            >
                              Send
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <hr className="horizontal"/> */}
      </div>
    </section>
  );
};

export default ContentUs;
